import { createFileRoute } from "@tanstack/react-router"

import TermsPage from "@/features/static/components/terms"

export const Route = createFileRoute("/_screen/terms")({
  component: Terms
})

function Terms() {
  return <TermsPage />
}
